import carLoan from '../../js/stores/car-loan.js';
import restrictedDate from '../stores/restricted-date.js';
import * as dayjs from 'dayjs';

const restrictedDatesLibrary = {
  disabledDates: [],
  listOngoing: [],
  listRestricted: [],

  async refreshDisabledDates (carId) {
    const listPrevious = this.previousDisabledDates();
    this.listOngoing = await this.ongoingList(carId);
    this.listRestricted = await this.restrictedList(carId);

    this.disabledDates = listPrevious;
    this.disabledDates = this.disabledDates.concat(this.listOngoing);
    this.disabledDates = this.disabledDates.concat(this.listRestricted);
  },

  previousDisabledDates () {
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    return [{
      from: new Date(2000, 0, 1),
      to: new Date(today.getFullYear(), today.getMonth(), today.getDate() + 3),
    }];
  },

  async ongoingList (carId) {
    let result = [];

    const list = await carLoan.dispatch('getOngoingList', carId);
    if (list.status !== undefined && list.status !== 200) {
      console.log(list.data.messages.error);
    }

    if (!(list.status == 400 || list.status == 404)) {
      result = list.map(item => { 
        return { from: new Date(dayjs(item.CarLoanStartDate).toDate()), to: new Date(dayjs(item.CarLoanEndDate).toDate()), };
      });
    }

    return result;
  },

  async restrictedList (carId) {
    let result = [];

    const list = await restrictedDate.dispatch('getListByCar', carId);
    if (list.status !== undefined && list.status !== 200) {
      console.log(list.data.messages.error);
    }

    if (!(list.status == 400 || list.status == 404)) {
      result = list.map(item => { return new Date(dayjs(item.RestrictedDate).toDate()) });
    }

    return result;
  },
};

export default restrictedDatesLibrary
